import { NotFoundPage } from "../../components";

export const Page404 = () => {
  return <NotFoundPage />;
};
